<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}</label>
    <div class="input-show-hide-password">
      <CInput :type="type" :value="value" ref="refInput"
              @input="$emit('input', $event)"
              @keyup.enter="$emit('keyup-enter', $event)"
              autofocus
              :autocomplete="autocomplete"
              :invalid-feedback="invalidFeedback"
              :class="[extraClasses]"
              :is-valid="isValid"
              :placeholder="placeholder">
        <template v-slot:invalid-feedback>
          <slot name="invalid-feedback"></slot>
        </template>

      </CInput>

      <a href="#" class="btn-eye" @click.prevent="toggleInputType" tabindex="-1">
        <CIcon :name="type === 'text' ? 'cip-eye': 'cip-eye-off' "/>
      </a>

    </div>
  </div>
</template>

<script>
export default {
  name: "InputPassword",
  props: {
    value: {type: String, required: false},
    extraClasses: {type: String, required: false},
    placeholder: {type: String, required: false},
    autocomplete: {type: String, required: false},
    isValid: {type: Boolean, required: false},
    invalidFeedback: {type: String, required: false},
    label: {type: String, required: false}
  },
  data() {
    return {
      type: 'password'
    }
  },
  methods: {
    toggleInputType() {
      this.type === 'password' ? this.type = 'text' : this.type = 'password'
      this.$refs.refInput.$el.children[0].focus()
    }
  }
}
</script>
